module.exports = "../study/imgs/maps/Nagano/S8/Ecosystem/Fagus/Nagano_Fagus_MIROC5_RCP26_Mid.png";